import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { mainMenuItems, adminMenuItems } from './config/menuItems';
import { useProfile } from '../../hooks/useProfile';
import type { MenuItem } from './types/navigation';

const MobileSubmenu = ({ item, onClose }: { item: MenuItem; onClose: () => void }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-4 py-2 text-content-secondary"
      >
        <span>{item.name}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && item.submenu && (
        <div className="bg-background py-2">
          {item.submenu.map((subItem) => (
            <NavLink
              key={subItem.path}
              to={subItem.path}
              onClick={onClose}
              className={({ isActive }) =>
                `block px-8 py-2 text-sm ${
                  isActive
                    ? 'text-brand bg-brand/10'
                    : 'text-content-secondary hover:text-content-primary hover:bg-background'
                }`
              }
            >
              {subItem.name}
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );
};

const MobileNavigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { profile } = useProfile();
  const isAdmin = profile?.admin === true; // Explicitly check for true
  
  // Combine menu items based on admin status
  const menuItems = isAdmin ? [...mainMenuItems, ...adminMenuItems] : mainMenuItems;

  const closeMenu = () => setIsOpen(false);

  return (
    <div className="md:hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 rounded-md text-content-secondary hover:text-content-primary hover:bg-background"
        aria-label="Toggle menu"
      >
        {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
      </button>

      {isOpen && (
        <div className="absolute top-16 left-0 right-0 bg-background-secondary border-b border-gray-800 shadow-lg z-50">
          <nav className="py-2">
            {menuItems.map((item) => (
              item.submenu ? (
                <MobileSubmenu
                  key={item.name}
                  item={item}
                  onClose={closeMenu}
                />
              ) : (
                <NavLink
                  key={item.name}
                  to={item.path!}
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    `flex items-center gap-2 px-4 py-2 ${
                      isActive
                        ? 'text-brand bg-brand/10'
                        : 'text-content-secondary hover:text-content-primary hover:bg-background'
                    }`
                  }
                >
                  <item.icon className="w-5 h-5" />
                  <span>{item.name}</span>
                </NavLink>
              )
            ))}
          </nav>
        </div>
      )}
    </div>
  );
};

export default MobileNavigation;